
/*
* 花びら全体を管理する
* サイズ（奥行き）ごとにコンテナを作る
*/

// 設定
import config from './config';
// グローバル変数
import valiable from './valiable';
// 花びらクラス
import SakuraClass from './SakuraClass';


export default class {

    /**
     * コンストラクタ
     * @param {PIXI.Container} container
     */
    constructor(target_container) {

        // 現在のページの設定
        this.page_config = config.PAGE_SETTINGS[config.PAGE_ACTIVE];
        // 描画先のコンテナ
        this.target_container = target_container;
        this.sprites_list = {};
        this.container_list = {};

        // サイズごとのコンテナと、花びらスプライト格納の準備
        config.SAKURA_CONTAINERS.forEach((v, i, a) => {
            this.sprites_list[v] = [];
            this.container_list[v] = new PIXI.Container();
        });
    }

    /**
    * 指定されたサイズのスプライト作成
    */
    setup(size) {

        const page = config.PAGE_ACTIVE;
        const container = this.container_list[size];
        const sprites = this.sprites_list[size];
        // 画面を任意の幅で分割した後の個数
        const divide_count = valiable.win_width / config.AREA_DEVIDE_WIDTH;
        // 最大配置数を画面分割数から算出
        const max = Math.floor(
            this.page_config.SAKURA_MAX[size] * divide_count);
        let scale = this.page_config.SAKURA_SCALE[size];

        // スマホならサイズ半分に
        if (valiable.win_width <= 500) {
            scale /= 2;
        }

        for (let i = 0; i < max; i += 1) {
            // 使用する桜画像IDを渡してスプライト作成
            // 引数は PIXI.load.add() で読み込ませた花びら画像の識別子name
            const idx = i % config.SAKURA_MAX_ID;
            const sprite_param = this.page_config.IMAGES.sakura[idx];
            const sakura = new SakuraClass(sprite_param.name);
            sakura.set_scale(scale);
            sprites.push(sakura);
            container.addChild(sakura.sprite);
        }
        this.target_container.addChild(container);
    }


    /**
    * ウィンドウサイズ変更されたら再配置
    */
    attach_random() {

        // 花びら再配置
        Object.keys(this.sprites_list).forEach((v, i, a) => {
            _attach_random(this.sprites_list[v]);
        });

        function _attach_random(sprites) {
            const length = sprites.length;
            sprites.forEach((v, i, a) => {
                // 指定範囲の中でランダム配置するように指令
                v.attach_random(
                    valiable.win_width, valiable.win_height
                );
            });
        }
    }

    /**
    * 落下
    */
    fall() {
        Object.keys(this.sprites_list).forEach((list_key, list_idx, list) => {
            const sprites = this.sprites_list[list_key];
            sprites.forEach((v, i, a) => {
                v.fall();
            });
        });
    }
}




// WEBPACK FOOTER //
// ./js/module/flower/SakuraControllerClass.js